// /analytics → redirect to /analytics/overview (REC-88).
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/analytics/')({
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/analytics/overview',
      search: search as Record<string, string>,
    });
  },
  component: () => null,
});
